import { useEffect, useState, useCallback } from "react";
import { api } from "../api";

/**
 * Günün maçları — tüm ligler, canlı skorlarla. Eskiden Ana Sayfa'daydı;
 * artık Tahmin sayfasının "Tüm Ligler" görünümü. Yalnızca LİSTE'yi çizer
 * (rapor paneli ebeveynde). getToday'i kendi çeker, canlı maç varken 30 sn'de
 * bir tazeler.
 *
 * Props:
 *   predictions          — tahmin listesi (kod rozeti + rapor için)
 *   queue                — analiz kuyruğu (satır durumu)
 *   onAdd(maçlar, lig, p)— toplu analiz kuyruğa ekle (addToQueue imzası)
 *   onView(prediction)   — bir tahmine tıklanınca (rapor göster)
 *   userAnalysisEnabled  — analiz açık mı
 */

const LEAGUE_GROUPS = [
  { country: "Türkiye",   flag: "https://flagcdn.com/24x18/tr.png",     leagues: ["Süper Lig"] },
  { country: "İngiltere", flag: "https://flagcdn.com/24x18/gb-eng.png", leagues: ["Premier League","Championship"] },
  { country: "İspanya",   flag: "https://flagcdn.com/24x18/es.png",     leagues: ["La Liga","Segunda Division"] },
  { country: "Almanya",   flag: "https://flagcdn.com/24x18/de.png",     leagues: ["Bundesliga","2. Bundesliga"] },
  { country: "İtalya",    flag: "https://flagcdn.com/24x18/it.png",     leagues: ["Serie A","Serie B"] },
  { country: "Fransa",    flag: "https://flagcdn.com/24x18/fr.png",     leagues: ["Ligue 1","Ligue 2"] },
  { country: "Hollanda",  flag: "https://flagcdn.com/24x18/nl.png",     leagues: ["Eredivisie"] },
  { country: "Belçika",   flag: "https://flagcdn.com/24x18/be.png",     leagues: ["Pro League"] },
  { country: "Portekiz",  flag: "https://flagcdn.com/24x18/pt.png",     leagues: ["Primeira Liga"] },
  { country: "Avrupa",    flag: "https://flagcdn.com/24x18/eu.png",     leagues: ["Champions League"] },
  { country: "Dünya",     flag: "https://flagcdn.com/24x18/un.png",     leagues: ["World Cup"] },
  { country: "Diğer",     flag: "https://flagcdn.com/24x18/un.png",     leagues: [
    "Scottish Premiership","Austrian Bundesliga","Super League Greece",
    "Russian Premier League","Superliga","Allsvenskan","Eliteserien","Swiss Super League",
  ]},
];

const LIVE_S = ["1H","2H","HT","ET","BT","P","LIVE"];

function localTime(match) {
  if (match.utc_datetime) {
    try { return new Date(match.utc_datetime).toLocaleTimeString([], { hour:"2-digit", minute:"2-digit", hour12:false }); } catch {}
  }
  return match.time || "";
}

function predCode(pred) {
  if (!pred) return null;
  const p = pred.toLowerCase();
  if (p.includes("beraberlik")) return "X";
  if (p.includes("deplasman") || p.includes("away")) return "2";
  return "1";
}

function MatchRow({ match, league, prediction, queueStatus, checked, onCheck, onPredict, onClick, canAnalyze = true }) {
  const isLive = LIVE_S.includes(match.status);
  const played = match.home_goals !== null && match.home_goals !== undefined && match.status === "FT";
  const hasScore = (played || isLive) && match.home_goals !== null;
  // "polling" = pipeline sürüyor (asıl analiz); "loading" = kısa POST anı.
  const analiz = queueStatus === "loading" || queueStatus === "polling";
  const inQueue = analiz || queueStatus === "waiting";
  const code = predCode(prediction?.prediction);
  // Analiz YALNIZCA başlamamış (NS) maçlara açık. Canlı ve biten maçlarda
  // analiz butonu gösterilmez (önceki hata: canlı maçta 'Analiz Et' çıkıyordu).
  const oynanmamis = !isLive && !played;

  return (
    <div
      onClick={() => prediction && onClick && onClick(prediction)}
      style={{
        display:"flex", alignItems:"center", padding:"8px 12px",
        borderBottom:"1px solid #f0f0f0", gap:8,
        background: isLive ? "#fff9f0" : analiz ? "#fffbeb" : queueStatus==="waiting" ? "#fefce8" : prediction && !played ? "#f9fffe" : "#fff",
        cursor: prediction ? "pointer" : "default",
        transition: "background 0.15s",
      }}
    >
      {/* Checkbox — yalnızca oynanmamış maçlar seçilebilir */}
      {oynanmamis ? (
        <input type="checkbox" checked={!!checked} onChange={e => { e.stopPropagation(); onCheck && onCheck(e.target.checked); }}
          style={{ width:14, height:14, cursor:"pointer", flexShrink:0 }} />
      ) : <div style={{ width:14, flexShrink:0 }} />}

      {/* Saat / durum */}
      <div style={{ width:36, fontSize:11, color: isLive?"#f59e0b":played?"#9ca3af":"#aaa", fontWeight:isLive?700:400, flexShrink:0, textAlign:"center" }}>
        {isLive ? (match.elapsed != null ? `${match.elapsed}'` : match.status) : played ? "FT" : localTime(match)}
      </div>

      {/* Ev */}
      <div style={{ flex:1, textAlign:"right", fontSize:13, fontWeight:500, color:"#222", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", paddingRight:8 }}>
        {match.home}
      </div>

      {/* Skor */}
      <div style={{ width:52, textAlign:"center", flexShrink:0 }}>
        {hasScore ? (
          <span style={{ fontSize:12, fontWeight:700, color:isLive?"#f59e0b":"#333", background:isLive?"#fff3cd":"#f0f0f0", padding:"2px 6px", borderRadius:4 }}>
            {match.home_goals} - {match.away_goals}
          </span>
        ) : <span style={{ fontSize:11, color:"#ddd" }}>vs</span>}
      </div>

      {/* Dep */}
      <div style={{ flex:1, fontSize:13, fontWeight:500, color:"#222", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", paddingLeft:8 }}>
        {match.away}
      </div>

      {/* Sağ aksiyon: canlı/biten maçta buton YOK */}
      <div style={{ width:90, textAlign:"right", flexShrink:0 }}>
        {!oynanmamis ? (
          // Canlı veya bitmiş: tahmin varsa kodu göster, yoksa boş
          code ? <span style={{ fontSize:11, padding:"2px 7px", borderRadius:3, background:"#16a34a", color:"#fff", fontWeight:700 }}>{code}</span> : null
        ) : inQueue ? (
          <span style={{ fontSize:14, animation: analiz?"spin 1s linear infinite":undefined }}>
            {analiz ? "⏳" : "⏸"}
          </span>
        ) : code ? (
          <span style={{ fontSize:11, padding:"2px 7px", borderRadius:3, background:"#16a34a", color:"#fff", fontWeight:700 }}>{code}</span>
        ) : (
          <button
            onClick={e => { if (!canAnalyze) return; e.stopPropagation(); onPredict && onPredict(match, league); }}
            disabled={!canAnalyze}
            style={{
              fontSize:12, padding:"3px 10px", borderRadius:4, whiteSpace:"nowrap", marginRight:2,
              border: canAnalyze ? "1px solid #2563eb" : "1px solid #e5e7eb",
              background:"#fff",
              color: canAnalyze ? "#2563eb" : "#d1d5db",
              cursor: canAnalyze ? "pointer" : "default",
              opacity: canAnalyze ? 1 : 0.5,
            }}>
            🎯 Analiz Et
          </button>
        )}
      </div>
    </div>
  );
}

export default function GununMaclari({ predictions = [], queue = [], onAdd, onView, userAnalysisEnabled = true }) {
  const [allMatches, setAllMatches] = useState({});
  const [loading, setLoading] = useState(true);
  const [checked, setChecked] = useState({});

  const fetchToday = useCallback(() => {
    api.getToday().catch(() => ({ leagues: {} })).then(r => {
      setAllMatches(r.leagues || {});
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchToday();
    // Canlı maç varken 30 sn'de bir skoru tazele
    let timer = null;
    const tick = () => {
      api.getToday().catch(() => ({ leagues: {} })).then(r => {
        setAllMatches(r.leagues || {});
        const hasLive = Object.values(r.leagues || {}).flat().some(x => LIVE_S.includes(x.status));
        if (hasLive && !timer) timer = setInterval(tick, 30000);
        else if (!hasLive && timer) { clearInterval(timer); timer = null; }
      });
    };
    tick();
    return () => { if (timer) clearInterval(timer); };
  }, [fetchToday]);

  const today = new Date().toISOString().slice(0, 10);

  // Seçilebilir (oynanmamış) bugünkü maçlar — checkbox indeksi için düz liste
  const secilebilir = [];
  LEAGUE_GROUPS.forEach(({ leagues }) => {
    leagues.forEach(league => {
      (allMatches[league] || []).forEach(m => {
        const isLive = LIVE_S.includes(m.status);
        const played = m.status === "FT";
        if (m.date === today && !isLive && !played) secilebilir.push({ ...m, league });
      });
    });
  });

  const checkedCount = Object.values(checked).filter(Boolean).length;
  const checkedMatches = secilebilir.filter((_, i) => checked[i]);

  const handleBulk = () => {
    if (!userAnalysisEnabled || checkedMatches.length === 0) return;
    // Aynı ligdekiler gruplanır; addToQueue lig bazlı çağrılır
    const byLeague = {};
    checkedMatches.forEach(m => { (byLeague[m.league] = byLeague[m.league] || []).push(m); });
    Object.entries(byLeague).forEach(([lg, ms]) => onAdd && onAdd(ms, lg, predictions));
    setChecked({});
  };

  return (
    <div>
      <style>{`@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }`}</style>

      {/* Toplu analiz çubuğu */}
      <div style={{ position:"sticky", top:0, zIndex:10, padding:"6px 12px", background:"#f9fafb", borderBottom:"1px solid #e5e7eb", display:"flex", alignItems:"center", justifyContent:"flex-end", gap:6 }}>
        {checkedCount > 0 && (
          <span style={{ fontSize:12, color:"#1d4ed8", fontWeight:600, marginRight:"auto" }}>{checkedCount} maç seçili</span>
        )}
        <button onClick={userAnalysisEnabled && checkedCount > 0 ? handleBulk : undefined}
          disabled={!userAnalysisEnabled}
          style={{
            padding:"3px 10px", borderRadius:4, fontSize:12, fontWeight:500,
            border: !userAnalysisEnabled ? "1px solid #e5e7eb" : checkedCount > 0 ? "1px solid #2563eb" : "1px solid #d1d5db",
            background:"#fff",
            color: !userAnalysisEnabled ? "#d1d5db" : checkedCount > 0 ? "#2563eb" : "#9ca3af",
            cursor: !userAnalysisEnabled || checkedCount === 0 ? "default" : "pointer",
            opacity: !userAnalysisEnabled ? 0.5 : 1,
          }}>
          🎯 Analiz Et
        </button>
        {checkedCount > 0 && (
          <button onClick={() => setChecked({})}
            style={{ padding:"3px 8px", borderRadius:4, border:"1px solid #d1d5db", background:"#fff", color:"#6b7280", fontSize:12, cursor:"pointer" }}>✕</button>
        )}
      </div>

      {loading && <div style={{ padding:32, textAlign:"center", color:"#aaa", fontSize:13 }}>Yükleniyor...</div>}

      {!loading && LEAGUE_GROUPS.map(({ country, flag, leagues }) => {
        const groupMatches = [];
        leagues.forEach(league => {
          (allMatches[league] || []).filter(m => m.date === today).forEach(m => groupMatches.push({ ...m, league }));
        });
        if (groupMatches.length === 0) return null;

        return (
          <div key={country}>
            <div style={{ display:"flex", alignItems:"center", gap:8, padding:"8px 12px", background:"#2d2d2d", position:"sticky", top: 40, zIndex:5 }}>
              <img src={flag} alt={country} style={{ width:20, height:14, borderRadius:2, objectFit:"cover" }} onError={e => e.target.style.display="none"} />
              <span style={{ fontSize:11, color:"#bbb" }}>{country}</span>
              {leagues.map(lg => <span key={lg} style={{ fontSize:12, fontWeight:700, color:"#fff" }}>{lg}</span>)}
              <span style={{ marginLeft:"auto", fontSize:10, color:"#888", background:"rgba(255,255,255,0.1)", padding:"1px 7px", borderRadius:8 }}>{groupMatches.length} maç</span>
            </div>

            {groupMatches.map((m, mi) => {
              const globalIdx = secilebilir.findIndex(x => x.home === m.home && x.away === m.away && x.league === m.league);
              const pred = predictions.find(p => p.home === m.home && p.away === m.away);
              const qItem = (queue || []).find(q => q.home === m.home && q.away === m.away);
              return (
                <MatchRow
                  key={mi}
                  match={m}
                  league={m.league}
                  prediction={pred || null}
                  queueStatus={qItem?.status}
                  checked={checked[globalIdx]}
                  onCheck={val => { if (globalIdx >= 0) setChecked(prev => ({ ...prev, [globalIdx]: val })); }}
                  onPredict={(match, league) => onAdd && onAdd([match], league, predictions)}
                  canAnalyze={userAnalysisEnabled}
                  onClick={onView}
                />
              );
            })}
          </div>
        );
      })}

      {!loading && Object.values(allMatches).flat().filter(m => m.date === today).length === 0 && (
        <div style={{ padding:48, textAlign:"center", color:"#bbb", fontSize:13 }}>
          <div style={{ fontSize:32, marginBottom:8 }}>⚽</div>
          Bugün maç yok
        </div>
      )}
    </div>
  );
}
